import React from "react";
import Undo from "../MenuItems/Undo";
import Redo from "../MenuItems/Redo";

const History = ({ editor, disabled }) => {
	return (
		<>
			<div className={`editor-menu-box`}>
				<Undo
					onClick={() => editor.chain().focus().undo().run()}
					isDisabled={disabled || !editor.can().chain().focus().undo().run()}
				/>
				<Redo
					onClick={() => editor.chain().focus().redo().run()}
					isDisabled={disabled || !editor.can().chain().focus().redo().run()}
				/>
			</div>
			<style>{`
            `}</style>
		</>
	);
};

export default History;
